import React from "react";
import { Carousel, Tabs, Button } from "antd";
import Router from "next/router";

const { TabPane } = Tabs;

class DepositLesson extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rapidIndex: 0,
            generalIndex: 0,
            toPage: 0,
            activepage: 1,
            changepage: false,
            autIndex: 0,
            coinWinIndex: 0,
            fireCoinIndex: 0,
            okxIndex: 0,
            coinSafeIndex: 0,
            niuYuIndex:0,
            soostIndex:0
        };

        this.rapidCryptoLessons = [
            {
                index: 0,
                id: "rapid-ls-1",
                content: () => <></>,
            },
            {
                index: 1,
                id: "rapid-ls-2",
                content: () => <></>,
            },
            {
                index: 2,
                id: "rapid-ls-3",
                content: () => <></>,
            },
            {
                index: 3,
                id: "rapid-ls-4",
                content: () => <></>,
            },
        ];

        this.rapidCryptoComment = [
            {
                id: 1,
                title: "步骤1",
                content: "如何进行极速虚拟币支付",
            },
            {
                id: 2,
                title: "步骤2",
                content: "重要提示",
            },
            {
                id: 3,
                title: "步骤3",
                content: "如何进行充值",
            },
            {
                id: 4,
                title: "步骤4",
                content: "如何添加钱包地址",
            },
            {
                id: 5,
                title: "步骤5",
                content: "确定添加",
            },
            {
                id: 6,
                title: "步骤6",
                content: "成功添加钱包地址",
            },
            {
                id: 7,
                title: "步骤7",
                content: "查看交易记录",
            },
            {
                id: 8,
                title: "",
                content: "",
            },
            {
                id: 8,
                title: "",
                content: "",
            },
        ];

        this.generalCryptoLessons = [
            {
                index: 0,
                id: "general-ls-1",
                content: () => <></>,
            },
            {
                index: 1,
                id: "general-ls-2",
                content: () => <></>,
            },
            {
                index: 2,
                id: "general-ls-3",
                content: () => <></>,
            },
            {
                index: 3,
                id: "general-ls-4",
                content: () => <></>,
            },
        ];

        this.generalCryptoComment = [
            {
                id: 1,
                title: "步骤1",
                content: "如何进行虚拟币支付 1",
            },
            {
                id: 2,
                title: "步骤2",
                content: "订单成立进入第三支付页面",
            },
            {
                id: 3,
                title: "步骤3",
                content: "选择需要支付的币种",
            },
            {
                id: 4,
                title: "步骤4",
                content: "扫描或复制地址进行支付",
            },
            {
                id: 5,
                title: "步骤5",
                content: "查看交易记录",
            },
            {
                id: 6,
                title: "",
                content: "",
            },
            {
                id: 7,
                title: "",
                content: "",
            },
        ];

        this.INVOICE_AUTComment = [
            {
                id: 1,
                title: "步骤1",
                content: "如何进行虚拟币支付 2",
            },
            {
                id: 2,
                title: "步骤2",
                content: "扫描或复制地址进行支付",
            },
            {
                id: 3,
                title: "步骤3",
                content: "提交成功",
            },
            {
                id: 4,
                title: "步骤4",
                content: "查看交易记录",
            },
            {
                id: 5,
                title: "",
                content: "",
            },
        ];
        this.INVOICE_AUTLessons = [
            {
                index: 0,
                id: "aut-ls-1",
                content: () => <></>,
            },
            {
                index: 1,
                id: "aut-ls-2",
                content: () => <></>,
            },
            {
                index: 2,
                id: "aut-ls-3",
                content: () => <></>,
            },
        ];

        this.CoinWinLessons = Array.from({length: 12}, (_,i)=>({index: i, id: 'coinwin-ls-'+(i+1), content: ()=><></>}));
        this.CoinWinComment = Array.from({length: 12}, (_,i)=>({id:i+1, title:'步骤'+(i+1)}));

        this.FireCoinLessons = Array.from({length: 11}, (_,i)=>({index: i, id: 'firecoin-'+(i+1)}));
        this.FireCoinComment = Array.from({length: 11}, (_,i)=>({id:i+1, title:'步骤'+(i+1)}));

        this.OKXCoinLessons = Array.from({length: 8}, (_,i)=>({index: i, id: 'okxcoin-ls-'+(i+1)}));
        this.OKXCoinComment = Array.from({length: 8}, (_,i)=>({id:i+1, title:'步骤'+(i+1)}));

        this.CoinSafeLessons = Array.from({length: 6}, (_,i)=>({index: i, id: 'coinsafe-ls-'+(i+1)}));
        this.CoinSafeComment = Array.from({length: 6}, (_,i)=>({id:i+1, title:'步骤'+(i+1)}));

        this.stsCryptoLessons = Array.from({length: 6}, (_,i)=>({index: i, id: 'sts-'+(i+1)}));
        this.stsCryptoComment = Array.from({length: 6}, (_,i)=>({id: i+1, title: '步骤'+(i+1)}));
        this.nyCryptoLessons = Array.from({length: 4}, (_,i)=>({index: i, id: 'ny-'+(i+1)}));
        this.nyCryptoComment = Array.from({length: 4}, (_,i)=>({id: i+1, title: '步骤'+(i+1)}));
    }

    componentDidMount() {
        document.addEventListener(
            "keydown",
            function (event) {
                event.stopPropagation();
                console.log(event);
            },
            true
        );
    }

    handleChange = (key) => {
        this.props.handleChangeDepositLessonTab(key);
    };

    handleClick = () => {
        console.log("close modal");
        this.props.onhandleCancel();
    };

    commonPreNextClick = (refName, type) => {
        return () => {
            console.log(refName, type)
            this.refs[refName].slick[type=='PRE' ? 'slickPrev' : 'slickNext']()
        }
    }

    commonOnChange = (idxName, n) => {
        this.setState({[idxName]: n})
    }

    goPage = () => {
        Router.push("/cn/USDTintroduce");
    };
    render() {
        const defaultTabNum = this.props.tabNum;

        return (
            <React.Fragment>
                <div className="lesson-box" style={{ textAlign: "center" }}>
                    <Tabs
                        defaultActiveKey={defaultTabNum.toString()}
                        activeKey={this.props.tabNum.toString()}
                        onChange={this.handleChange}
                        centered={true}
                        keyboard={false}
                    >{
                        [{
                            TAB: '极速虚拟币支付',
                            REF: 'RapidSlider',
                            LESSONS: this.rapidCryptoLessons,
                            INDEX_NAME: 'rapidIndex',
                            COMMENT: this.rapidCryptoComment,
                        },{
                            TAB: '虚拟币支付 1',
                            REF: 'GeneralSlider',
                            LESSONS: this.generalCryptoLessons,
                            INDEX_NAME: 'generalIndex',
                            COMMENT: this.generalCryptoComment,
                        },{
                            TAB: '虚拟币支付 2',
                            REF: 'autSlider',
                            LESSONS: this.INVOICE_AUTLessons,
                            INDEX_NAME: 'autIndex',
                            COMMENT: this.INVOICE_AUTComment,
                        },
                        {
                            TAB: '速斯特交易所',
                            REF: 'sstSlider',
                            LESSONS: this.stsCryptoLessons,
                            INDEX_NAME: 'soostIndex',
                            COMMENT: this.stsCryptoComment,
                        },
                        {
                            TAB: '牛易交易所',
                            REF: 'nySlider',
                            LESSONS: this.nyCryptoLessons,
                            INDEX_NAME: 'niuYuIndex',
                            COMMENT: this.nyCryptoComment,
                        },{
                            TAB: '币赢交易所',
                            REF: 'coinWinSlider',
                            LESSONS: this.CoinWinLessons,
                            INDEX_NAME: 'coinWinIndex',
                            COMMENT: this.CoinWinComment,
                        },{
                            TAB: '火币交易所',
                            REF: 'fireCoinSlider',
                            LESSONS: this.FireCoinLessons,
                            INDEX_NAME: 'fireCoinIndex',
                            COMMENT: this.FireCoinComment,
                        },{
                            TAB: 'OKX交易所',
                            REF: 'okxCoinSlider',
                            LESSONS: this.OKXCoinLessons,
                            INDEX_NAME: 'okxIndex',
                            COMMENT: this.OKXCoinComment,
                        },{
                            TAB: '币安交易所',
                            REF: 'coinSafeSlider',
                            LESSONS: this.CoinSafeLessons,
                            INDEX_NAME: 'coinSafeIndex',
                            COMMENT: this.CoinSafeComment,
                        }
                        ].map((child, idx) => {
                        return <TabPane tab={child.TAB} key={idx+1}>
                            <Carousel
                                key={idx}
                                ref={child.REF}
                                className="custom-Carousel"
                                afterChange={(current) => {
                                    this.commonOnChange(child.INDEX_NAME, current)
                                }}
                            >
                                {child?.LESSONS.map((item, index) => (
                                    <div
                                        key={item.id}
                                        className={`crypto-lesson-wrap ${item.id}`}
                                    >
                                        <div className="crypto-lesson-body">
                                            {item.content ? item.content() : <></>}
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                            {this.state[child.INDEX_NAME] > 0 && (
                                <div
                                    className="left-next"
                                    onClick={this.commonPreNextClick(child.REF, 'PRE')}
                                >
                                    <img
                                        className="arrowLeftRight"
                                        src={
                                            "/cn/img/depositlesson/icon-left.svg"
                                        }
                                        alt="left"
                                    />
                                </div>
                            )}
                            {this.state[child.INDEX_NAME] !=
                                child.LESSONS.length - 1 && (
                                <div
                                    className="right-next"
                                    onClick={this.commonPreNextClick(child.REF, 'NEXT')}
                                >
                                    <img
                                        className="arrowLeftRight"
                                        src={
                                            "/cn/img/depositlesson/icon-right.svg"
                                        }
                                        alt="right"
                                    />
                                </div>
                            )}
                            {/* {child.COMMENT && child.COMMENT.length && <div className="deposit-comment-title">
                                {
                                    child.COMMENT[
                                        this.state[child.INDEX_NAME]
                                    ].title
                                }
                            </div>} */}
                            <div className="line-distance"></div>
                        </TabPane>
                        })
                    }
                    </Tabs>
                </div>
                <div></div>
            </React.Fragment>
        );
    }
}
export default DepositLesson;
